import { useRef } from 'react'

import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  Button,
  useToast,
  useDisclosure,
} from '@chakra-ui/react'
import { useDispatch } from 'react-redux'

import { reactivateStaff } from '../../redux/features/staffSlice'

const ReactivateStaffButton = ({ onSuccess }) => {
  const cancelRef = useRef(null)
  const toast = useToast()
  const dispatch = useDispatch()
  const { isOpen, onOpen, onClose } = useDisclosure()
  const handleSuccess = () => {
    toast({
      title: 'Staff reactivated',
      description: `Staff was reactivated.`,
      status: 'success',
    })
    onClose()
    onSuccess()
  }

  const handleReactivate = () => {
    dispatch(reactivateStaff({ callbackSuccess: handleSuccess }))
  }

  return (
    <>
      <Button colorScheme='green' variant='solid' onClick={onOpen}>
        Reactivate
      </Button>
      <AlertDialog
        isOpen={isOpen}
        leastDestructiveRef={cancelRef}
        onClose={onClose}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize='lg' fontWeight='bold'>
              Reactivate Staff
            </AlertDialogHeader>

            <AlertDialogBody>
              Are you sure? Reactivating will give this staff access to Council
              Connect. New credentials will be sent to their email.
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose}>
                Cancel
              </Button>
              <Button colorScheme='green' onClick={handleReactivate} ml={3}>
                Reactivate Staff
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  )
}

export default ReactivateStaffButton
